/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetGenericListCommandDto,
  GetHistoryByGranularityCommand,
  GetHistoryByGranularityResponse,
  MarkAllAsReadCommand,
  MarkAsReadCommand,
  OperationResponse,
  SearchActivityFeedResponse,
  SearchNotificationsCommand,
  SearchNotificationsResponse,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetGenericListCommandDtoFromJSON,
    GetGenericListCommandDtoToJSON,
    GetHistoryByGranularityCommandFromJSON,
    GetHistoryByGranularityCommandToJSON,
    GetHistoryByGranularityResponseFromJSON,
    GetHistoryByGranularityResponseToJSON,
    MarkAllAsReadCommandFromJSON,
    MarkAllAsReadCommandToJSON,
    MarkAsReadCommandFromJSON,
    MarkAsReadCommandToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SearchActivityFeedResponseFromJSON,
    SearchActivityFeedResponseToJSON,
    SearchNotificationsCommandFromJSON,
    SearchNotificationsCommandToJSON,
    SearchNotificationsResponseFromJSON,
    SearchNotificationsResponseToJSON,
} from '../models/index';

export interface GetHistoryByBorrowerProjectAsyncRequest {
    borrowerProjectId: string;
    getHistoryByGranularityCommand: GetHistoryByGranularityCommand;
}

export interface GetHistoryByGranularityAsyncRequest {
    risqueAssureId: string;
    getHistoryByGranularityCommand: GetHistoryByGranularityCommand;
}

export interface MarkAllAsReadAsyncRequest {
    markAllAsReadCommand: MarkAllAsReadCommand;
}

export interface MarkAsReadAsyncRequest {
    id: string;
    markAsReadCommand: MarkAsReadCommand;
}

export interface SearchActivityFeedAsyncRequest {
    getGenericListCommandDto: GetGenericListCommandDto;
}

export interface SearchNotificationsAsyncRequest {
    searchNotificationsCommand: SearchNotificationsCommand;
}

/**
 * 
 */
export class ActivityFeedApi extends runtime.BaseAPI {

    /**
     * Retrieves the activity feed history for a borrower project. Merges the activity feeds of all borrowers in the project, sorted by descending date.  ## Granularity Levels  ### Level 1 - Resume Returns major events only.  ### Level 2 - Standard Returns important events with grouped details: - Major events displayed individually (isMajor=true) - Minor events grouped by entity type and 59-minute time window - Groups contain details accessible via hover/expansion  ### Level 3 - Complete Returns all events without any grouping.  ## Response Structure - For levels 1 and 3: use the `events` array (`groups` is null) - For level 2: use the `groups` array (`events` is null) 
     * Get activity feed history for a borrower project
     */
    async getHistoryByBorrowerProjectAsyncRaw(requestParameters: GetHistoryByBorrowerProjectAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHistoryByGranularityResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling getHistoryByBorrowerProjectAsync().'
            );
        }

        if (requestParameters['getHistoryByGranularityCommand'] == null) {
            throw new runtime.RequiredError(
                'getHistoryByGranularityCommand',
                'Required parameter "getHistoryByGranularityCommand" was null or undefined when calling getHistoryByBorrowerProjectAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/flux-activite/projets-emprunts/{borrowerProjectId}/historique`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetHistoryByGranularityCommandToJSON(requestParameters['getHistoryByGranularityCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHistoryByGranularityResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the activity feed history for a borrower project. Merges the activity feeds of all borrowers in the project, sorted by descending date.  ## Granularity Levels  ### Level 1 - Resume Returns major events only.  ### Level 2 - Standard Returns important events with grouped details: - Major events displayed individually (isMajor=true) - Minor events grouped by entity type and 59-minute time window - Groups contain details accessible via hover/expansion  ### Level 3 - Complete Returns all events without any grouping.  ## Response Structure - For levels 1 and 3: use the `events` array (`groups` is null) - For level 2: use the `groups` array (`events` is null) 
     * Get activity feed history for a borrower project
     */
    async getHistoryByBorrowerProjectAsync(requestParameters: GetHistoryByBorrowerProjectAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHistoryByGranularityResponse> {
        const response = await this.getHistoryByBorrowerProjectAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the activity feed history for a specific insured risk with a configurable granularity level.  ## Granularity Levels  ### Level 1 - Resume Returns major events only: - Simulation created - Quote created - Quote PDF generated - SEPA mandate created/sent/signed - Contract created/sent/signed - Certificate generated - Events with High or Urgent priority  ### Level 2 - Standard Returns important events with grouped details: - Major events displayed individually (isMajor=true) - Minor events grouped by entity type and 59-minute time window - Groups contain details accessible via hover/expansion  ### Level 3 - Complete Returns all events without any grouping.  ## Response Structure - For levels 1 and 3: use the `events` array (`groups` is null) - For level 2: use the `groups` array (`events` is null) 
     * Get activity feed history with granularity level
     */
    async getHistoryByGranularityAsyncRaw(requestParameters: GetHistoryByGranularityAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetHistoryByGranularityResponse>> {
        if (requestParameters['risqueAssureId'] == null) {
            throw new runtime.RequiredError(
                'risqueAssureId',
                'Required parameter "risqueAssureId" was null or undefined when calling getHistoryByGranularityAsync().'
            );
        }

        if (requestParameters['getHistoryByGranularityCommand'] == null) {
            throw new runtime.RequiredError(
                'getHistoryByGranularityCommand',
                'Required parameter "getHistoryByGranularityCommand" was null or undefined when calling getHistoryByGranularityAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/flux-activite/risques/{risqueAssureId}/historique`.replace(`{${"risqueAssureId"}}`, encodeURIComponent(String(requestParameters['risqueAssureId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetHistoryByGranularityCommandToJSON(requestParameters['getHistoryByGranularityCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetHistoryByGranularityResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the activity feed history for a specific insured risk with a configurable granularity level.  ## Granularity Levels  ### Level 1 - Resume Returns major events only: - Simulation created - Quote created - Quote PDF generated - SEPA mandate created/sent/signed - Contract created/sent/signed - Certificate generated - Events with High or Urgent priority  ### Level 2 - Standard Returns important events with grouped details: - Major events displayed individually (isMajor=true) - Minor events grouped by entity type and 59-minute time window - Groups contain details accessible via hover/expansion  ### Level 3 - Complete Returns all events without any grouping.  ## Response Structure - For levels 1 and 3: use the `events` array (`groups` is null) - For level 2: use the `groups` array (`events` is null) 
     * Get activity feed history with granularity level
     */
    async getHistoryByGranularityAsync(requestParameters: GetHistoryByGranularityAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetHistoryByGranularityResponse> {
        const response = await this.getHistoryByGranularityAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks all activity feed entries as read for a given risk and context. Context: GlobalNotification (1) or RiskHistory (2) 
     * Mark all entries as read
     */
    async markAllAsReadAsyncRaw(requestParameters: MarkAllAsReadAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['markAllAsReadCommand'] == null) {
            throw new runtime.RequiredError(
                'markAllAsReadCommand',
                'Required parameter "markAllAsReadCommand" was null or undefined when calling markAllAsReadAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/flux-activite/read-all`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MarkAllAsReadCommandToJSON(requestParameters['markAllAsReadCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Marks all activity feed entries as read for a given risk and context. Context: GlobalNotification (1) or RiskHistory (2) 
     * Mark all entries as read
     */
    async markAllAsReadAsync(requestParameters: MarkAllAsReadAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.markAllAsReadAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marque toutes les notifications de l\'utilisateur connecté comme lues (pas de body). Appelé à l\'ouverture du panneau notifications ou via « Tout marquer lu ». La consultation (POST /notifications) ne marque plus rien ; en vue Plateforme cette route est un no-op côté back (safe dans tous les cas). 
     * Mark all notifications as read
     */
    async markAllNotificationsAsReadAsyncRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/flux-activite/notifications/read-all`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Marque toutes les notifications de l\'utilisateur connecté comme lues (pas de body). Appelé à l\'ouverture du panneau notifications ou via « Tout marquer lu ». La consultation (POST /notifications) ne marque plus rien ; en vue Plateforme cette route est un no-op côté back (safe dans tous les cas). 
     * Mark all notifications as read
     */
    async markAllNotificationsAsReadAsync(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.markAllNotificationsAsReadAsyncRaw(initOverrides);
        return await response.value();
    }

    /**
     * Marks a specific activity feed entry as read in a given context. Context: GlobalNotification (1) or RiskHistory (2) 
     * Mark entry as read
     */
    async markAsReadAsyncRaw(requestParameters: MarkAsReadAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling markAsReadAsync().'
            );
        }

        if (requestParameters['markAsReadCommand'] == null) {
            throw new runtime.RequiredError(
                'markAsReadCommand',
                'Required parameter "markAsReadCommand" was null or undefined when calling markAsReadAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/flux-activite/{id}/read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MarkAsReadCommandToJSON(requestParameters['markAsReadCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Marks a specific activity feed entry as read in a given context. Context: GlobalNotification (1) or RiskHistory (2) 
     * Mark entry as read
     */
    async markAsReadAsync(requestParameters: MarkAsReadAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.markAsReadAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a paginated list of activity feed entries for a specific insured risk. Results include both historical events and actions. 
     * Search activity feed entries
     */
    async searchActivityFeedAsyncRaw(requestParameters: SearchActivityFeedAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchActivityFeedResponse>> {
        if (requestParameters['getGenericListCommandDto'] == null) {
            throw new runtime.RequiredError(
                'getGenericListCommandDto',
                'Required parameter "getGenericListCommandDto" was null or undefined when calling searchActivityFeedAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/flux-activite/liste`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetGenericListCommandDtoToJSON(requestParameters['getGenericListCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchActivityFeedResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of activity feed entries for a specific insured risk. Results include both historical events and actions. 
     * Search activity feed entries
     */
    async searchActivityFeedAsync(requestParameters: SearchActivityFeedAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchActivityFeedResponse> {
        const response = await this.searchActivityFeedAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a paginated list of global notification entries for the current user. Supports infinite scroll with page-based pagination. Results are sorted by creation date in descending order. 
     * Search global notifications
     */
    async searchNotificationsAsyncRaw(requestParameters: SearchNotificationsAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchNotificationsResponse>> {
        if (requestParameters['searchNotificationsCommand'] == null) {
            throw new runtime.RequiredError(
                'searchNotificationsCommand',
                'Required parameter "searchNotificationsCommand" was null or undefined when calling searchNotificationsAsync().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/flux-activite/notifications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchNotificationsCommandToJSON(requestParameters['searchNotificationsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchNotificationsResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of global notification entries for the current user. Supports infinite scroll with page-based pagination. Results are sorted by creation date in descending order. 
     * Search global notifications
     */
    async searchNotificationsAsync(requestParameters: SearchNotificationsAsyncRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchNotificationsResponse> {
        const response = await this.searchNotificationsAsyncRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
